import { render, staticRenderFns } from "./ReplaySettings.vue?vue&type=template&id=76062496&scoped=true&"
import script from "./ReplaySettings.vue?vue&type=script&lang=ts&"
export * from "./ReplaySettings.vue?vue&type=script&lang=ts&"
import style0 from "./ReplaySettings.vue?vue&type=style&index=0&id=76062496&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76062496",
  null
  
)

export default component.exports